import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import userperfil from "../../images/userperfil.png";
import logoImg from "../../images/ModuloCapacitacion/Logo.png";
import grupoFarinterImg from "../../images/ModuloCapacitacion/grupoFarinter.png";
import moment from 'moment';
import "../../css/resumenEvaluacionEstilo.css";


export const ResumenEvaluacionPuestoPDF = ({ rowData }) => {
  const renderSwitch = (param) => {
    switch (param.type) {
      case "paragraph":
        return (
          <p
            style={{
              textAlign: `${param.data.alignment}`,
            }}
            dangerouslySetInnerHTML={{ __html: param.data.text }}
          />
        );
      case "header":
        switch (param.data.level) {
          case 1:
            return (
              <h1
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 2:
            return (
              <h1
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 3:
            return (
              <h3
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 4:
            return (
              <h4
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 5:
            return (
              <h5
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 6:
            return (
              <h6
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          default:
            return null;
        }
      case "breakLine":
        return <br />;
      default:
        return null;

    }
  };

  const ColorCriticidad = (criticidad) => {
    switch (criticidad) {
      case 'Baja Criticidad':
        return 'bg-success'
      case 'Media Criticidad':
        return 'bg-warning text-dark'
      case 'Alta Criticidad':
        return 'bg-danger'
      default:
        return 'bg-secondary'
    }
  }

  const criticidadColor = ColorCriticidad(rowData.criticidad_nombre.trim())
  const vulerabilidad = rowData.info_matriz?.find(item => item.tipo_criticidad === "Vulnerabilidad");
  const vulerabilidadProm = vulerabilidad ? vulerabilidad.criticidad_promedio.promedio : 0
  const negocio = rowData.info_matriz?.find(item => item.tipo_criticidad === "Negocio");
  const negocioProm = negocio ? negocio.criticidad_promedio.promedio : 0
  const negocioPos = negocioProm * 20; // 0 a 100
  const vulnerabilidadPos = vulerabilidadProm * 20; // 0 a 100

  function convertirPalabraAVertical(palabra) {
    return palabra.split('').join('<br>');
  }


  return (
    <>

      <div id='prueba' style={{ position: 'absolute', top: "-99999999999px" }}>
        <div className='custom-wrapper'>
          <div className='container-fluid' id='impresion1'>
            <Col>
              <Row>
                <Col md={6} className='d-flex flex-wrap justify-content-center align-items-center'>
                  <img
                    src={logoImg}
                    style={{ width: '40%' }}
                    alt='LogoAurora'
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={grupoFarinterImg}
                    style={{ width: "40%" }}
                    alt="LogoFarinter"
                  />
                </Col>
              </Row>
            </Col>
            <Row style={{ backgroundColor: '#141E30', color: 'white' }} className='rounded py-3 my-3 d-flex flex-wrap justify-content-center align-items-center'>
              <h4>Resumen de Evaluación de Puesto</h4>
            </Row>
            <Container>
              <Row className="align-items-end">
                <Col md={4} lg={5} className="mt-2">
                  <span style={{ fontSize: '1rem' }}>Función:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '0.90rem', marginLeft: '4px', whiteSpace: 'normal' }}>{rowData.descriptor[0].list_posicion[0].codigo + ' / ' + rowData.descriptor[0].list_posicion[0].descripcion}</span>
                </Col>
                <Col md={3} lg={3} className="mt-2">
                  <span style={{ fontSize: '1rem' }}>Empresa:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px', whiteSpace: 'normal' }}>{rowData.descriptor[0].list_empresa[0].nombre}</span>
                </Col>
                <Col md={3} lg={3} className="mt-2">
                  <span style={{ fontSize: '1rem' }}>Área:</span>  <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px', whiteSpace: 'normal' }}>{rowData.descriptor[0].list_division[0].descripcion}</span>
                </Col>
              </Row>
            </Container>
            <Row className="mx-4">
            <Col md={8}>
              {/* Primer Row */}
              <Row>
                <Col sm={12}>

                  <Row className="align-items-end mt-3">
                    {/* <Col sm={4} className="mr-2" style={{ marginTop: '5px', marginBottom:'30px' }}>
                      <span className={`badge badge-pill ${criticidadBadge}`} style={{ fontSize: '1rem', width: '300px', height: '30px', alignContent: 'center' }}>{rowData.criticidad_nombre}</span>
                    </Col> */}
                    <Container className="mt-4">
                      <Row className="align-items-start mb-5">
                        <Col lg={4} xs="auto" className='mt-2'>
                          <div className={`${criticidadColor} text-white text-center p-2`} style={{ fontWeight: "bold" }}>{rowData.criticidad_nombre}</div>
                          
                        </Col>
                        <Col lg={7} className="mt-2" style={{ marginRight: '30px' }}>
                          <div style={{ width: "100%" }}>
                            <table className="table table-bordered table-sm" >
                              <thead>
                                <tr>
                                  <th className='text-center' colSpan={5}>Nivel de Criticidad</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th className={rowData.criticidad_promedio == 1 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>1</th>
                                  <th className={rowData.criticidad_promedio == 2 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>2</th>
                                  <th className={rowData.criticidad_promedio == 3 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>3</th>
                                  <th className={rowData.criticidad_promedio == 4 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>4</th>
                                  <th className={rowData.criticidad_promedio == 5 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>5</th>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>

                      <Row className='mb-4'>
                        <Container fluid>
                        {rowData.info_matriz.map((criticidad) => {
                            let tipoCriticidad = convertirPalabraAVertical(criticidad.tipo_criticidad)
                            return (
                              <Row className='mb-5'>
                                <Col sm={1} className='texto-vertical contenedor-titulos-pdf' dangerouslySetInnerHTML={{__html: tipoCriticidad}}>                                 
                                  
                                </Col>
                                <Col sm={11}>
                                  <Container className='contenedor-factores'>
                                    {criticidad.factores.map((factor) => {
                                      return (
                                        <Row>
                                          <Col className='contenedor-titulos-pdf text-center align-middle' sm={3}>
                                            {factor.factor_criticidad}
                                          </Col>
                                          <Col sm={9} style={{ paddingLeft: "6px" }}>
                                            <Container>
                                              <Row className='contenedor-factores'>
                                                {factor.factores.map((criterio) => {
                                                  return (
                                                    <Col sm={11} style={{ paddingRight: "6px" }}>
                                                      <table className="table table-bordered table-sm m-0" >
                                                        <thead>
                                                          <tr>
                                                            <th className='text-center table-primary' colSpan={5}>{criterio.factor_criterio}</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr>
                                                            <th className={criterio.valor_criticidad == 1 && "bg-success"} style={{ textAlign: 'center' }}>1</th>
                                                            <th className={criterio.valor_criticidad == 2 && "bg-success"} style={{ textAlign: 'center' }}>2</th>
                                                            <th className={criterio.valor_criticidad == 3 && "bg-success"} style={{ textAlign: 'center' }}>3</th>
                                                            <th className={criterio.valor_criticidad == 4 && "bg-success"} style={{ textAlign: 'center' }}>4</th>
                                                            <th className={criterio.valor_criticidad == 5 && "bg-success"} style={{ textAlign: 'center' }}>5</th>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </Col>
                                                  )

                                                })}

                                              </Row>

                                            </Container>
                                          </Col>

                                        </Row>
                                      )
                                    })}
                                  </Container>
                                </Col>
                              </Row>
                            )

                          })}

                          


                        </Container>

                      </Row>


                    </Container>
                    {/* 
                    <Col sm={3} className="mt-2" style={{ marginRight: '30px' }}>
                      <div>
                        <table className="table table-bordered" style={{ marginBottom: '-1px' }}>
                          <thead>
                            <tr>
                              <th rowSpan={'5'} style={{ textAlign: 'center' }}>Nivel de Criticidad</th>
                            </tr>
                          </thead>
                        </table>
                        <table className="table table-bordered ">
                          <tbody>
                            <tr>
                              <th className="table-warning" style={{ textAlign: 'center' }}>1</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>2</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>3</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>4</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>5</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col> */}

                  </Row>

                </Col>
              </Row>


            </Col>

            {/* Segundo Row */}
            <Col md={3}>
              <Row>
                <Col sm={3} className="mt-5" style={{ verticalAlign: 'top' }}>
                  <div>
                    <table className="table table-bordered" style={{ marginBottom: '-1px', borderColor: 'black' }}>
                      <tbody>
                        {rowData.info_matriz.map((item, index) => (
                          <tr key={index}>
                            <td className="table-primary">{item.tipo_criticidad}</td>
                            <td className="table-light">{item.criticidad_promedio.promedio}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Container className="chart-container position-relative">
                  {/* Titulos de los ejes */}
                  <div className="axis-title x-axis-title">Vulnerabilidad</div>
                  <div className="axis-title y-axis-title">Negocio</div>

                  <Row className="h-50">
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'yellow', fontWeight: "bold", color: "#000" }}>
                      Media Criticidad
                    </Col>
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'red', fontWeight: "bold", color: "#000" }}>
                      Alta Criticidad
                    </Col>
                  </Row>
                  <Row className="h-50">
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'lightgreen', fontWeight: "bold", color: "#000" }}>
                      Baja Criticidad
                    </Col>
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'yellow', fontWeight: "bold", color: "#000" }}>
                      Media Criticidad
                    </Col>
                  </Row>

                  {/* Líneas y etiquetas */}
                  <div className="line vertical-line" style={{ left: `${vulnerabilidadPos}%`, bottom: '0%', height: `${negocioPos}%` }} />
                  <div className="line horizontal-line" style={{ top: `${100 - negocioPos}%`, left: '0%', width: `${vulnerabilidadPos}%` }} />

                  {/* Punto de intersección */}
                  <div className="intersection-point" style={{ left: `calc(${vulnerabilidadPos}% - 5px)`, top: `calc(${100 - negocioPos}% - 5px)` }} />

                  {/* Etiquetas de los valores */}
                  <div className="axis-label" style={{ left: `${vulnerabilidadPos}%`, bottom: '-20px' }}>
                    {vulerabilidadProm}
                  </div>
                  <div className="axis-label" style={{ top: `${100 - negocioPos}%`, left: '-20px' }}>
                    {negocioProm}
                  </div>

                  {/* Etiquetas de los extremos */}
                  <div className="axis-end-label" style={{ left: '-10%', bottom: '-35px', fontWeight: "bold" }}>0</div>
                  <div className="axis-end-label" style={{ left: '100%', bottom: '-35px', fontWeight: "bold" }}>5</div>
                  <div className="axis-end-label" style={{ top: '0%', left: '-10%', fontWeight: "bold" }}>5</div>
                </Container>
                {/* <Col sm={4} className="mt-2 mr-2">
                  <div style={{ border: '1px solid black', padding: '20px', width: '300px', height: '300px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <Container style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Row>
                          <Row>
                            <div style={{ border: '1px solid black', width: '80%', height: '80%' }}>
                              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                                <div style={{ width: '50%', height: '100px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'yellow' }}>
                                  <div style={{ marginTop: '25px' }}> Media Criticidad</div>
                                </div>
                                <div style={{ width: '50%', height: '100px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'red' }}>
                                  <div style={{ marginTop: '25px' }}> Alta Criticidad</div>
                                </div>
                                <div style={{ width: '50%', height: '105px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'green' }}>
                                  <div style={{ marginTop: '25px' }}> Baja Criticidad</div>
                                </div>
                                <div style={{ width: '50%', height: '105px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'yellow' }}>
                                  <div style={{ marginTop: '25px' }}> Media Criticidad</div>
                                </div>
                              </div>
                            </div>
                          </Row>
                          <Row className='text-center'>
                              Vulnerabilidad
                          </Row>

                        </Row>

                      </Container>
                    </div>

                  </div>
                </Col> */}

              </Row>
              <Row className='mt-5'>
                <Col sm={6} className="mt-2 mr-2">
                  <span style={{ fontSize: '1rem' }}>Fecha de Evaluación:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px' }}>{moment(rowData.fecha_creacion).format('DD-MM-YYYY')}</span>
                </Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2">
                  <span style={{ fontSize: '1rem' }}>Responsable:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px' }}>{rowData.empleado[0].nombre}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          </div>
        </div>
        {/* <Container fluid>
          <div id='impresion1' className='mt-5'>
            <Col>
              <Row>
                <Col md={6} className='d-flex flex-wrap justify-content-center align-items-center'>
                  <img 
                    src={logoImg}
                    style={{width: '40%'}}
                    alt='LogoAurora'
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={grupoFarinterImg}
                    style={{ width: "40%" }}
                    alt="LogoFarinter"
                  />
                </Col>
              </Row>
            </Col>
            <Row style={{backgroundColor: '#141E30', color: 'white'}} className='rounded py-3 my-3 d-flex flex-wrap justify-content-center align-items-center'>
              <h4>Resumen de Evaluación de Puesto</h4>
            </Row>
            <Row className='d-flex flex-wrap justify-content-center align-items-center'>
              <Col sm={12}>
                <Row className='aline-items-end'>
                <Col sm={6} className='mt-2 mr-2'>
                  <span style={{fontSize: '2rem'}}>Función :</span> <span className="badge badge-pill badge-light" style={{fontSize: '2rem', marginLeft: '4px'}}>{rowData.descriptor[0].list_posicion[0].codigo + ' / ' + rowData.descriptor[0].list_posicion[0].descripcion}</span>
                </Col>
                <Col sm={3} className='mt-2'>
                  <span style={{fontSize: '2rem'}}>Empresa :</span> <span className="badge badge-pill badge-light" style={{fontSize: '2rem',  marginLeft: '4px'}}>{rowData.descriptor[0].list_empresa[0].nombre}</span>
                </Col>
                <Col sm={2} className='mt-2'>
                  <span style={{fontSize: '2rem'}}>Área :</span>  <span className="badge badge-pill badge-light" style={{fontSize: '2rem',  marginLeft: '4px'}}>{rowData.descriptor[0].list_division[0].descripcion}</span>
                </Col>
                </Row>
              </Col>
            </Row>
            <Row className='aline-items-end mt-4'>
                <Col sm={4} className='mr-2' style={{marginTop:'60px'}}>
                  <span className={`badge badge-pill ${criticidadBadge}`}  style={{fontSize: '2rem', width:'300px', height:'70px', alignContent:'center'}}>{rowData.criticidad_nombre}</span>
                </Col>
                <Col sm={4} className='mt-2' style={{marginRight:'40px', marginTop:'50px'}}>
                  <div>
                    <table className='table table-bordered' style={{marginBottom: '-1px', marginTop:'70px'}}>
                      <thead>
                        <tr>
                          <th rowSpan={'5'} style={{textAlign: 'center', fontSize:'2rem'}}>Nivel de Criticidad</th>  
                        </tr>
                      </thead>
                    </table>
                    <table className='table table-bordered '>
                    <tbody>
                    <tr>
                          <th className='table-warning' style={{ textAlign: 'center', fontSize:'2rem' }}>1</th>
                          <th className='table-warning' style={{ textAlign: 'center', fontSize:'2rem' }}>2</th>
                          <th className='table-warning' style={{ textAlign: 'center', fontSize:'2rem' }}>3</th>
                          <th className='table-warning' style={{ textAlign: 'center', fontSize:'2rem' }}>4</th>
                          <th className='table-warning' style={{ textAlign: 'center', fontSize:'2rem' }}>5</th>
                      </tr>
                    </tbody>
                    </table>
                  </div>
                </Col>
                <Col sm={3} className='mt-2' style={{verticalAlign:'top'}}>
                  <div>
                      <table className='table table-bordered' style={{marginBottom: '-1px', borderColor:'black', marginTop:'50px'}}>
                        <tbody>
                          {rowData.info_matriz.map((item, index) => (
                            <tr key={index}>
                              <td className='table-primary' style={{fontSize:'2rem'}}>{item.tipo_criticidad}</td>
                              <td class="table-light" style={{fontSize:'2rem'}}>{item.total_criticidad}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                </Col>
            </Row>
            <Row className='aline-items-end mt-3'>
              {rowData.info_matriz.map((item, index) => (
                <>
                   <Col sm={6} className='mr-2' style={{marginTop:'30px', marginLeft:'5px', display:'flex'}} key={index}>
                    <div style={{textAlign: 'center', border: '1px solid black', borderRadius: '5px',padding: '40px', width:'fit-content', marginLeft:'20px', fontSize: '2rem'}}>
                            {item.tipo_criticidad.split('').map((letter, letterIndex) =>(
                              <div key={letterIndex}>
                                {letter}
                              </div>
                            ))}
                                          </div>
                      <div style={{marginLeft: '20px', marginTop: '50px'}}>
                        {item.factores.map((factor, factorIndex) => (
                            <div key={factorIndex} style={{border: '1px solid black', borderRadius: '5px', padding: '10px', width: 'fit-content', marginTop: '25px', fontSize: '2rem'}}>
                                {factor.criticidad_nombre}
                            </div>
                        ))}
                    </div>
                   </Col>
                   <Col sm={4} className='mt-2' style={{marginRight:'50px'}}>
                    <div>
                        {item.factores.map((factor, factorIndex) => (
                         <>
                             <table className='table table-bordered' style={{marginBottom: '-1px'}} key={factorIndex} id={`table_${index}_${factorIndex}`}>
                            <thead>
                              <tr>
                                <th rowSpan={'5'} style={{textAlign: 'center', fontSize:'2rem'}}>{factor.factor_nombre}</th>
                              </tr>
                            </thead> 
                          </table>
                          <table className='table table-bordered'>
                            <tbody>
                              <tr>
                                {[1,2,3,4,5].map((numero) =>(
                                  <td key={numero} style={{textAlign: 'center', backgroundColor: factor.factor_Marca === numero ? 'green' : 'white', fontSize:'2rem'}}>
                                    {numero}
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </table>
                         </>
                         
                        ))}
                    </div>
                    </Col>
                </>
              ))}
            </Row>
            <Row className='aline-items-end mt-3'>
            <Col sm={4}></Col> 
              <Col sm={4}></Col> 
              <Col sm={3} className='mt-4'>
                  <span style={{fontSize: '2rem'}}>Fecha de Evaluación :</span> <span className="badge badge-pill badge-light" style={{fontSize: '2rem'}}>{moment(rowData.fecha_creacion).format('DD-MM-YYYY')}</span>
              </Col>
              <Col sm={4}></Col> 
              <Col sm={4}></Col> 
              <Col sm={3} className='mt-4'>
                  <span style={{fontSize: '2rem'}}>Responsable :</span> <span className="badge badge-pill badge-light" style={{fontSize: '2rem'}}>{rowData.empleado[0].nombre}</span>
              </Col>
            </Row>
          </div> */}


        {/* </Container>*/}
      </div>
    </>
  )
}
